import httpClient from "./httpClient";

const entityEndpoint = "/suppliers";

export default {
  async getAll() {
    const response = await httpClient.get(entityEndpoint);
    return response.data;
  },

  async delete(id) {
    const response = await httpClient.delete(`${entityEndpoint}/${id}`);
    return response.data;
  },

  async create(supplier) {
    const response = await httpClient.post(entityEndpoint, {
      ...supplier
    });
    return response.data;
  },

  async update(supplier) {
    const response = await httpClient.put(`${entityEndpoint}/${supplier.id}`, {
      ...supplier
    });
    return response.data;
  },

  async addWorker(supplierId, workerId) {
    let url = `${entityEndpoint}/${supplierId}/staff`;
    const response = await httpClient.post(
      url,
      {
        workerId
      },
      { errorHandle: false }
    );
    return response.data;
  },

  async removeWorker(supplierId, workerId) {
    let url = `${entityEndpoint}/${supplierId}/staff/${workerId}`;
    const response = await httpClient.delete(url);
    return response.data;
  },

  async addGuide(supplierId, guideId) {
    let url = `${entityEndpoint}/${supplierId}/guides`;
    const response = await httpClient.post(
      url,
      {
        guideId
      },
      { errorHandle: false }
    );
    return response.data;
  },

  async removeGuide(supplierId, guideId) {
    let url = `${entityEndpoint}/${supplierId}/guides/${guideId}`;
    const response = await httpClient.delete(url);
    return response.data;
  }
};
